module.exports = __webpack_public_path__ + "img/level1_running_shadow.17b1b49c.png";